import { useEffect, useMemo, useState } from 'react';
import { useFetch } from '../../../hooks/useFetch';
import { ContractSettingsApiFactory } from '../api/contractSettingsApi';

/**
 * Installation "Contract activation" option, read from the Contract tab's own route
 * (`employee_record.contract`) so the tab does not depend on the `employee_list` line.
 * `undefined` until the response arrives, and when the call fails.
 */
export function useContractActivationOption(): boolean | undefined {
  const [client] = useFetch();
  const api = useMemo(() => ContractSettingsApiFactory(client), [client]);
  const [enabled, setEnabled] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const ctrl = new AbortController();
    api
      .getContractSettings({ signal: ctrl.signal })
      .then(settings => setEnabled(settings.contractActivationEnabled))
      .catch(() => {
        if (ctrl.signal.aborted) return;
        setEnabled(undefined);
      });
    return () => ctrl.abort();
  }, [api]);

  return enabled;
}
